import React from 'react';
import { graphql, compose } from 'react-apollo';
import BaseWidget from '../../../../widgets/baseWidget';
import { getPrayingStatistics } from './queries/queries';
import { ByHourPrayingTimeDistribution } from '../../common/charts/byHourPrayingTimeDistribution';
import DataProcessor from '../../common/dataProcessors/prayingDataProcessor';
import PrayingWidget from '../../common/widgets/praying';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class Praying extends BaseWidget {
  get statisticsData() {
    return this.props.data.statistics.churchManager.group.daily.praying;
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData, 'day');
  }

  render() {
    return (
      <PrayingWidget data={this.dataProcessor.data} loading={this.props.data.loading} title="Daily Praying"
                     comment={this.comment}>
        <ByHourPrayingTimeDistribution data={this.dataProcessor.chartData}
                                       pointTooltip={this.dataProcessor.pointTooltip}
                                       timezone={this.props.timezone} />
      </PrayingWidget>
    )
  }
}

export default compose(
  graphql(getPrayingStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(Praying);




// WEBPACK FOOTER //
// ./src/components/pages/statistics/group/daily/praying.js